import { useQuery } from '@tanstack/react-query';
import { getCreditBalance } from '../../services/credits';
import { queryKeys } from '../../lib/queryKeys';

export function useCreditBalance(supabaseId: string | undefined) {
  return useQuery({
    queryKey: queryKeys.credits(supabaseId!),
    queryFn: () => getCreditBalance(supabaseId!).then(r => r.credits),
    enabled: !!supabaseId,
    staleTime: 5_000,    // 5s — intentionally short for credits
    gcTime: 30_000,
    // refetchOnWindowFocus inherited (true). Tab-back refetches credits
    // after 5s — intentional since user may return from Stripe.
  });
}
